import { forwardRef, type SVGProps } from "react";

export const SearchIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Search</title>
        <path
          d="M15.75 15.75L10.75 10.75M12.4167 6.58333C12.4167 9.80499 9.80499 12.4167 6.58333 12.4167C3.36167 12.4167 0.75 9.80499 0.75 6.58333C0.75 3.36167 3.36167 0.75 6.58333 0.75C9.80499 0.75 12.4167 3.36167 12.4167 6.58333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
SearchIcon.displayName = "SearchIcon";

export const SortIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Sort</title>
        <path
          d="M5.41667 17.0834V2.91675M5.41667 2.91675L2.5 5.83341M5.41667 2.91675L8.33333 5.83341"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5834 2.91658V17.0833M14.5834 17.0833L11.6667 14.1666M14.5834 17.0833L17.5 14.1666"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
SortIcon.displayName = "SortIcon";

export const ChapterMenuIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Chapter menu</title>
      <path
        d="M2.01855 11.25C2.43271 11.2501 2.76855 11.5858 2.76855 12C2.76855 12.4142 2.43271 12.7499 2.01855 12.75H2.00879C1.59477 12.7498 1.25879 12.4141 1.25879 12C1.25879 11.5859 1.59477 11.2502 2.00879 11.25H2.01855ZM14 11.25C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H5.70508C5.29105 12.7498 4.95508 12.4141 4.95508 12C4.95508 11.5859 5.29105 11.2502 5.70508 11.25H14ZM2.00879 7.25C2.423 7.25 2.75879 7.58579 2.75879 8C2.75879 8.41421 2.423 8.75 2.00879 8.75H2C1.58579 8.75 1.25 8.41421 1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H2.00879ZM14 7.25C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H5.70508C5.29105 8.74979 4.95508 8.41408 4.95508 8C4.95508 7.58592 5.29105 7.25021 5.70508 7.25H14ZM2.01855 3.25C2.43271 3.25006 2.76855 3.58583 2.76855 4C2.76855 4.41417 2.43271 4.74994 2.01855 4.75H2.00879C1.59477 4.74977 1.25879 4.41407 1.25879 4C1.25879 3.58593 1.59477 3.25023 2.00879 3.25H2.01855ZM14 3.25C14.4142 3.25 14.75 3.58579 14.75 4C14.75 4.41421 14.4142 4.75 14 4.75H5.70508C5.29105 4.74979 4.95508 4.41408 4.95508 4C4.95508 3.58592 5.29105 3.25021 5.70508 3.25H14Z"
        fill="currentColor"
      />
    </svg>
  );
});
ChapterMenuIcon.displayName = "ChapterMenuIcon";

export const PinIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Pin</title>
        <path
          d="M8 13.9973V10.6875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3441 10.6883C12.2705 10.1099 12.081 9.232 11.5423 8.30938C11.2651 7.83442 10.9606 7.45876 10.6892 7.17163V3.65492C10.6892 2.74058 9.9486 2 9.03425 2H6.9656C6.05126 2 5.31068 2.74058 5.31068 3.65492V7.17163C5.03845 7.45876 4.73394 7.83442 4.45757 8.30938C3.91972 9.232 3.72941 10.1099 3.65576 10.6883H12.3441Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
PinIcon.displayName = "PinIcon";

export const HomeIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Home</title>
        <path
          d="M7.75 14.0019H8H8.25V10.7519C8.25 10.6138 8.13807 10.5019 8 10.5019C7.86193 10.5019 7.75 10.6138 7.75 10.7519V14.0019Z"
          fill="currentColor"
        />
        <path
          d="M9 13.2519H12.5C12.9142 13.2519 13.25 12.9161 13.25 12.5019V6.80463C13.25 6.55388 13.1247 6.3197 12.916 6.18061L8.41602 3.18061C8.1641 3.01268 7.8359 3.01268 7.58398 3.18061L3.08398 6.18061C2.87535 6.3197 2.75001 6.55388 2.75 6.80463V12.5019C2.75 12.9161 3.08579 13.2519 3.5 13.2519H7V10.7519C7 10.1996 7.44771 9.7519 8 9.7519C8.55228 9.7519 9 10.1996 9 10.7519V13.2519ZM14.75 12.5019C14.75 13.7445 13.7426 14.7519 12.5 14.7519H3.5C2.25736 14.7519 1.25 13.7445 1.25 12.5019V6.80463C1.25001 6.05235 1.62602 5.34985 2.25195 4.93256L6.75195 1.93256C7.50772 1.42873 8.49228 1.42873 9.24805 1.93256L13.748 4.93256C14.374 5.34985 14.75 6.05235 14.75 6.80463V12.5019Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
HomeIcon.displayName = "HomeIcon";

export const CloseIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (
    { color = "currentColor", "aria-hidden": ariaHidden = true, ...props },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Close</title>
        <path
          d="M3.5 12.5L12.5 3.5M3.5 3.5L12.5 12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
CloseIcon.displayName = "CloseIcon";

export const ChevronLeftIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(
  (
    { color = "currentColor", "aria-hidden": ariaHidden = true, ...props },
    ref,
  ) => {
    return (
      <svg
        aria-hidden={ariaHidden}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <title>Chevron left</title>
        <path
          d="M10.3999 13.5984L4.7999 7.99844L10.3999 2.39844"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
ChevronLeftIcon.displayName = "ChevronLeftIcon";

export const ChevronRightIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(
  (
    { color = "currentColor", "aria-hidden": ariaHidden = true, ...props },
    ref,
  ) => {
    return (
      <svg
        aria-hidden={ariaHidden}
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <title>Chevron right</title>
        <path
          d="M5.6001 2.39961L11.2001 7.99961L5.6001 13.5996"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
ChevronRightIcon.displayName = "ChevronRightIcon";

export const WarningIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(
  (
    {
      color = "currentColor",
      height = 16,
      width = 18,
      title = "Warning",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 16"
        fill="none"
      >
        <title>{title}</title>
        <path
          d="M7.01543 1.61667L0.987638 12.0612C0.315415 13.2277 1.15542 14.6834 2.50097 14.6834H14.5566C15.9021 14.6834 16.7421 13.2277 16.0699 12.0612L10.0421 1.61667C9.36987 0.461111 7.68765 0.461111 7.01543 1.61667Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.52881 5.23828V8.57161"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.52881 12.7378C7.91547 12.7378 7.41769 12.2378 7.41769 11.6267C7.41769 11.0156 7.91547 10.5156 8.52881 10.5156C9.14214 10.5156 9.63992 11.0157 9.63992 11.6267C9.63992 12.2377 9.14214 12.7378 8.52881 12.7378Z"
          fill={color}
        />
      </svg>
    );
  },
);
WarningIcon.displayName = "WarningIcon";

export const CheckMarkIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <title>Check mark</title>
        <path
          d="M3.75 10.625L7.5002 14.7915L16.25 6.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
CheckMarkIcon.displayName = "CheckMarkIcon";

export const HeartIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        {...props}
      >
        <title>Heart</title>
        <path
          d="M11.8594 3.8916C13.3215 2.36943 15.6785 2.36943 17.1406 3.8916C18.6193 5.43147 18.6193 7.9406 17.1406 9.48047L10 16.917L2.85938 9.48047C1.38072 7.9406 1.38072 5.43147 2.85938 3.8916C4.32147 2.36943 6.67853 2.36943 8.14062 3.8916L9.45898 5.26465L10 5.82812L10.541 5.26465L11.8594 3.8916Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  },
);
HeartIcon.displayName = "HeartIcon";

export const HeartFilledIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <title>Filled heart</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.31803 3.36359C4.07539 1.54547 6.92463 1.54547 8.68199 3.36359L10 4.74516L11.318 3.36359C13.0754 1.54547 15.9246 1.54547 17.682 3.36359C19.4393 5.18171 19.4393 8.16989 17.682 10L10 18L2.31803 10C0.560666 8.16989 0.560666 5.18171 2.31803 3.36359Z"
        fill="currentColor"
      />
    </svg>
  );
});
HeartFilledIcon.displayName = "HeartFilledIcon";

export const GlobeIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <title>Globe</title>
        <g clipPath="url(#clip0_3306_8180)">
          <path
            d="M18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346M18.3334 10.0013C18.3334 5.39893 14.6025 1.66797 10.0001 1.66797M18.3334 10.0013H1.66675M10.0001 18.3346C5.39771 18.3346 1.66675 14.6037 1.66675 10.0013M10.0001 18.3346C7.86028 16.0878 6.66675 13.104 6.66675 10.0013C6.66675 6.89858 7.86028 3.91476 10.0001 1.66797M10.0001 18.3346C12.1399 16.0878 13.3334 13.104 13.3334 10.0013C13.3334 6.89858 12.1399 3.91476 10.0001 1.66797M1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3306_8180">
            <rect width="20" height="20" fill={color} />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
GlobeIcon.displayName = "GlobeIcon";

export const InfoCircleIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(({ title = "Info circle", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g clipPath="url(#info-circle-icon-clip)">
        <path
          d="M17.3953 10.0017C17.3953 5.91724 14.0847 2.60569 10.0002 2.60547C5.91564 2.60547 2.604 5.9171 2.604 10.0017C2.60422 14.0861 5.91577 17.3967 10.0002 17.3967C14.0845 17.3965 17.395 14.086 17.3953 10.0017ZM19.2703 10.0017C19.27 15.1215 15.1201 19.2715 10.0002 19.2717C4.88024 19.2717 0.729224 15.1217 0.729004 10.0017C0.729004 4.88157 4.8801 0.730469 10.0002 0.730469C15.1202 0.730688 19.2703 4.8817 19.2703 10.0017Z"
          fill="currentColor"
        />
        <path
          d="M9.0625 13.75V10C9.0625 9.48223 9.48223 9.0625 10 9.0625C10.5178 9.0625 10.9375 9.48223 10.9375 10V13.75C10.9375 14.2678 10.5178 14.6875 10 14.6875C9.48223 14.6875 9.0625 14.2678 9.0625 13.75Z"
          fill="currentColor"
        />
        <path
          d="M9.99881 7.72222C9.38547 7.72222 8.8877 7.22222 8.8877 6.61111C8.8877 6 9.38547 5.5 9.99881 5.5C10.6121 5.5 11.1099 6.00011 11.1099 6.61111C11.1099 7.22211 10.6121 7.72222 9.99881 7.72222Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="info-circle-icon-clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});
InfoCircleIcon.displayName = "InfoCircleIcon";

export const QuestionMarkIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(({ title = "Question mark", ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      ref={ref}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_1518_18153)">
        <path
          d="M10 18.3346C14.6024 18.3346 18.3334 14.6037 18.3334 10.0013C18.3334 5.39893 14.6024 1.66797 10 1.66797C5.39765 1.66797 1.66669 5.39893 1.66669 10.0013C1.66669 14.6037 5.39765 18.3346 10 18.3346Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.01 13.9622H10.017M10.01 11.2449C10.6354 9.86025 12.1168 9.96238 12.1168 8.33933C12.1168 7.24975 11.4145 6.16016 10.01 6.16016C8.923 6.16016 8.25667 6.81278 8.01093 7.61294"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1518_18153">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});
QuestionMarkIcon.displayName = "QuestionMarkIcon";

export const PlusIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(({ color = "currentColor", title = "Plus", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M8 3V13M13 8L3 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
PlusIcon.displayName = "PlusIcon";

export const MinusIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(({ color = "currentColor", title = "Minus", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M13 8H3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
MinusIcon.displayName = "MinusIcon";

export const EllipsisHorizontalIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ color = "currentColor", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <title>More options</title>
      <path
        d="M4.16659 10.0013H4.17492M9.99992 10.0013H10.0083M15.8333 10.0013H15.8416M4.99992 10.0013C4.99992 10.4615 4.62682 10.8346 4.16659 10.8346C3.70635 10.8346 3.33325 10.4615 3.33325 10.0013C3.33325 9.54106 3.70635 9.16797 4.16659 9.16797C4.62682 9.16797 4.99992 9.54106 4.99992 10.0013ZM10.8333 10.0013C10.8333 10.4615 10.4602 10.8346 9.99992 10.8346C9.53968 10.8346 9.16659 10.4615 9.16659 10.0013C9.16659 9.54106 9.53968 9.16797 9.99992 9.16797C10.4602 9.16797 10.8333 9.54106 10.8333 10.0013ZM16.6666 10.0013C16.6666 10.4615 16.2935 10.8346 15.8333 10.8346C15.373 10.8346 14.9999 10.4615 14.9999 10.0013C14.9999 9.54106 15.373 9.16797 15.8333 9.16797C16.2935 9.16797 16.6666 9.54106 16.6666 10.0013Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
EllipsisHorizontalIcon.displayName = "EllipsisHorizontalIcon";

export const OpenLinkIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        {...props}
      >
        <title>Open link</title>
        <path
          d="M6.41038 1.88208H2.73113C1.63698 1.88208 0.75 2.76906 0.75 3.86321V13.7689C0.75 14.863 1.63698 15.75 2.73113 15.75H12.6368C13.7309 15.75 14.6179 14.863 14.6179 13.7689V10.0896M10.9387 0.75H15.75M15.75 0.75V5.56132M15.75 0.75L7.54245 8.95755"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

OpenLinkIcon.displayName = "OpenLinkIcon";

export const SidebarToggleIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Toggle sidebar</title>
      <path
        d="M7.08337 3.33594V16.6693"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3334 15.0026V5.0026C18.3334 4.08213 17.5872 3.33594 16.6667 3.33594L3.33337 3.33594C2.4129 3.33594 1.66671 4.08213 1.66671 5.0026V15.0026C1.66671 15.9231 2.4129 16.6693 3.33337 16.6693H16.6667C17.5872 16.6693 18.3334 15.9231 18.3334 15.0026Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
});
SidebarToggleIcon.displayName = "SidebarToggleIcon";
